import { FC, MouseEvent } from 'react'
import { noop } from 'lodash-es'
import Button from '../Button'
import SVGIcon from '../SVGIcon'

type AnnouncementProps = {
  id?: string | number | null
  message?: string
  onDismiss?: (id: string | number | null) => void
}

const Announcement: FC<AnnouncementProps> = ({ id = null, message = '', onDismiss = noop }) => {
  const handleDismiss = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    onDismiss(id)
  }

  return (
    <div className="announcement">
      <div className="announcement__body">{message}</div>
      <div className="announcement__dismiss">
        <Button onClick={handleDismiss} className="button-reset dismiss-button" title="Close">
          <SVGIcon xlinkHref="#streamline-delete-1" alt="Dismiss" pointerEvents="none" className="no-fill" />
        </Button>
      </div>
    </div>
  )
}

export default Announcement
